import { render, staticRenderFns } from "./PackageStatus.vue?vue&type=template&id=130296aa&scoped=true&"
import script from "./PackageStatus.vue?vue&type=script&lang=js&"
export * from "./PackageStatus.vue?vue&type=script&lang=js&"
import style0 from "./PackageStatus.vue?vue&type=style&index=0&id=130296aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130296aa",
  null
  
)

export default component.exports